export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14958.4fa1bc12.jpg";